<template>
    <div v-if="user"
         class="d-block text-center fixed-top border-bottom border-light bg-dark text-light">
        Kontostand: {{computedBalance | kies}}
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            transientBalanceAdjustment: Number
        },
        computed: {
            ...mapGetters(['user']),
            computedBalance() {
                return this.user.balance + (this.transientBalanceAdjustment ? this.transientBalanceAdjustment : 0)
            }
        }
    }
</script>
